import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { MiscService } from '../../_service/misc.service';
import { LeadsService } from 'src/app/_service/leads.service';
declare var $: any;

@Component({
  selector: 'app-add-update-specialties',
  templateUrl: './add-update-specialties.component.html',
  styleUrls: ['./add-update-specialties.component.css']
})
export class AddUpdateSpecialtiesComponent implements OnInit {

  specialtiesForm: FormGroup; submitted = false; loading: boolean = false; specialtiesId: any = ''; myrole: string;

  constructor(private router: Router, private sharedapi: SharedService, private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute, public miscapi: MiscService, private leadapi: LeadsService,) {

    this.specialtiesForm = this.formBuilder.group({
      'name': [null, Validators.required],
      'image_icon': [null],
      'status': [null, Validators.required],
      'description': [null],
      'treatment': [null],
      'show_in_glamyo_health': [null],
      'show_in_glamyo_dental': [null],
      'online_consultation': [null],

    });

    this.activatedRoute.params.subscribe(params => {
      if (params['specialtie_id']) {
        this.specialtiesId = params['specialtie_id'];
        this.patchTreatmentData();
      }

    });
  }

  get f() { return this.specialtiesForm.controls; }

  async patchTreatmentData() {
    this.miscapi.getSpecialtiesData(this.specialtiesId).subscribe((response: any) => {
      if (response.status) {
        this.specialtiesForm.patchValue({
          'name': response.data.name,
          'status': response.data.status,
          'description': response.data.description,
          'treatment': response.data.treatment,
          'show_in_glamyo_health': response.data.show_in_glamyo_health,
          'show_in_glamyo_dental': response.data.show_in_glamyo_dental,
          'online_consultation': response.data.online_consultation,
        })
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  ngOnInit(): void {
    this.sharedapi.getRole().subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
  }



  async createTreatment() {
    this.submitted = true;
    this.loading = true;
    // if (this.specialtiesForm.invalid) {
    //     this.loading = false;
    //     return;
    // }
    //For Update Specialties//
    if (this.specialtiesId) {

      if (this.specialtiesForm.invalid) {
        this.loading = false;
        return;
      }
      this.specialtiesForm.value.id = parseInt(this.specialtiesId);
      await this.miscapi.updateSpecialties(this.specialtiesForm.value)
        .subscribe((data: any) => {
          this.submitted = false;
          this.loading = false;
          if (data.status) {
            this.sharedapi.presentToast('Treatment Update Successfully');
            this.router.navigateByUrl('/specialties');
          }
          else {
            this.sharedapi.presentToast(data.msg);
          }
        }, error => {
          this.sharedapi.checkError(error);
        });
    } else {
      //For Add Specialties//
      this.specialtiesForm.controls['image_icon'].setValidators(Validators.required);
      this.specialtiesForm.controls['image_icon'].updateValueAndValidity();
      if (this.specialtiesForm.invalid) {
        this.loading = false;
        return;
      }
      await this.miscapi.addSpecialties(this.specialtiesForm.value)
        .subscribe((data: any) => {
          this.submitted = false;
          this.loading = false;
          if (data.status) {
            this.sharedapi.presentToast('Specialties Added Successfully');
            this.router.navigateByUrl('/specialties');
          }
          else {
            this.sharedapi.presentToast(data.msg);
          }
        }, error => {
          this.sharedapi.checkError(error);
        });
    }
  }

  selectPic(event) {
    const file = (event.target as HTMLInputElement).files[0];
    this.specialtiesForm.patchValue({
      image_icon: file
    });
  }

}
